<template>
    <div>
        <b-button @click="showCarouselGallery = true"><i class="fa fa-eye"></i></b-button>
        <b-modal v-model="showCarouselGallery" hide-header hide-footer>
            <b-carousel
                controls
                :interval="0"
            >

            <b-carousel-slide v-for="(img, i) in value"
                :img-src="img.localURL"
                :key="i"
            ></b-carousel-slide>
                
            </b-carousel>
        </b-modal>
    </div>
</template>

<script>
export default {
    props: {
        value: {
            type: Array,
            default: function() {
                return []
            }
        }
    },
    data: function() {
        return {
            showCarouselGallery: false
        }
    }
}
</script>